import React from 'react';

const LinkedIn = (props) => (
  <svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.2675 28.0004H0.4625V9.3066H6.2675V28.0004ZM3.36188 6.7566C1.50563 6.7566 0 5.2191 0 3.36285C1.32862e-08 2.47123 0.354197 1.61612 0.98467 0.985647C1.61514 0.355173 2.47025 0.000976562 3.36188 0.000976562C4.2535 0.000976562 5.10861 0.355173 5.73908 0.985647C6.36955 1.61612 6.72375 2.47123 6.72375 3.36285C6.72375 5.2191 5.2175 6.7566 3.36188 6.7566ZM27.9937 28.0004H22.2013V18.9004C22.2013 16.7316 22.1575 13.9504 19.1831 13.9504C16.165 13.9504 15.7025 16.3066 15.7025 18.7441V28.0004H9.90375V9.3066H15.4712V11.8566H15.5525C16.3275 10.3879 18.2206 8.83785 21.045 8.83785C26.92 8.83785 28 12.7066 28 17.7316V28.0004H27.9937Z" fill="white"/>
  </svg>
);

export default LinkedIn;
